import Splitting from "splitting";

Splitting({
  target: "[data-splitting-jumping]",
  by: "chars",
  key: null,
  whitespace: true,
});

function handleAnimation(entries) {
  entries.forEach((entry) => {
    const chars = entry.target.querySelectorAll(".char");
    chars.forEach((char, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          char.classList.add("animate");
        }, index);
      } else {
        char.classList.remove("animate");
      }
    });
  });
}

// Trigger animation when scrolled into view
const jumpingText = document.querySelectorAll(".jumping-text");
const observer = new IntersectionObserver(handleAnimation, {
  threshold: 0.5,
});

jumpingText.forEach((text) => {
  observer.observe(text);
});
